import { Loader } from '../ui';

/**
 * Loading indicator shown during route transitions
 */
export function RouteLoader() {
  return <Loader variant="page" message="Loading..." />;
}
